import { useQuery } from '@tanstack/react-query';
import { cardsAPI } from '../api/modules/cards.module';

export const suggestedPriceKeys = {
  all: ['listingSuggestedPrice'],
  detail: (productId, finish, condition) => [
    ...suggestedPriceKeys.all,
    productId,
    finish ?? null,
    condition ?? null,
  ],
};

// Fresh market price for a catalog card. The backend synchronously
// re-fetches from JustTCG when the price is stale (once per card per UTC
// day) — mount this at card-select time so that latency hides behind the
// steps before pricing. Keyed by (product, finish, condition): changing
// the finish re-fetches and the shown price tracks the selection.
export const useListingSuggestedPrice = (productId, finish, condition) => {
  return useQuery({
    queryKey: suggestedPriceKeys.detail(productId, finish, condition),
    queryFn: () => cardsAPI.getListingSuggestedPrice({ productId, finish, condition }),
    enabled: !!productId,
  });
};
